const state = {
    settings: null
};
const actions = {
    setCompanySettings({ commit }, payload) {
        commit('updateCompanySettings', payload);
    }
};

const mutations = {
    updateCompanySettings(state, payload) {
        state.settings = payload;

    }
};

export const companySettingsModule = {
    namespaced: true,
    state,
    actions,
    mutations
};
